import { gpObserveServerTime } from './corrected-clock'
import { observationFromDateHeader } from './server-time-from-http'

/** Where the request handler leaves the local clock for the response handler. */
const REQUEST_START_KEY = '__gpRequestStartMs';

/**
 * Feeds the corrected clock from the `Date` header on responses the app was
 * already making (#763).
 *
 * Thin on purpose: the estimate itself is `observationFromDateHeader`, which is
 * specified without Angular anywhere near it. All this does is time the round
 * trip and hand the header over.
 */
export function gpServerTimeHttpInterceptor() {

    return {
        request(config: ng.IRequestConfig) {
            (config as any)[REQUEST_START_KEY] = Date.now();
            return config;
        },

        response(response: ng.IHttpResponse<any>) {
            try {
                const requestStartMs = (response.config as any)?.[REQUEST_START_KEY];
                if (typeof requestStartMs === 'number') {
                    const observation = observationFromDateHeader(
                        response.headers('Date'),
                        requestStartMs,
                        Date.now());

                    if (observation) {
                        gpObserveServerTime(observation);
                    }
                }
            } catch (e) {
                // Reading the clock is never a reason to fail somebody's request.
            }

            return response;
        },
    };
}
